<template>
  <v-sheet color="#f5f5f5" min-height="100%">
    <ListPageTemplate v-bind="settings" :items="items">
      <template #item="{ item }">
        <v-col class="py-0 px-1 px-sm-3 mt-6 mt-md-10" cols="6" md="4">
          <ArticleCard v-bind="item" />
        </v-col>
      </template>
    </ListPageTemplate>
  </v-sheet>
</template>

<script>
import ListPageTemplate from "../components/templates/ListPageTemplate.vue";
import ArticleCard from "../components/cards/ArticleCard.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  title: "Notícias",
  mod: "articles",
  path: "/noticias",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  loading: true,
  totalItems: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  created() {
    this.getList();
  },
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    settings() {
      return {
        title: _config.title,
        loading: this.loading,
        pagesLength: this.pagesLength,
      };
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
  },
  methods: {
    getList() {
      const params = {
        ..._pagination,
        page: this.page,
      };

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (params.returnTotalItems) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            }
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    page() {
      this.getList();
    },
  },
  components: {
    ListPageTemplate,
    ArticleCard,
  },
};
</script>
